var path = 'visualizer/js/modules/core/dataTableRecordCount/dataTableRecordCount.tpl.html';
var html = "<span id=filteredRecordCount title={{recordCount.displayString}}> {{recordCount.displayString}} </span> ";
window.angular.module('templates-visualizer').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;